import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=c32d003e&scoped=true"
import script from "./SizeChart.vue?vue&type=script&lang=js"
export * from "./SizeChart.vue?vue&type=script&lang=js"
import style0 from "./SizeChart.vue?vue&type=style&index=0&id=c32d003e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32d003e",
  null
  
)

export default component.exports